import { HStack, Text, VStack } from "@chakra-ui/react"

export type ResortStatsRow = {
  label: string
  value: string
}

type ResortStatsTableProps = {
  rows: ResortStatsRow[]
}

export default function ResortStatsTable({ rows }: ResortStatsTableProps) {
  if (rows.length === 0) {
    return null
  }

  return (
    <VStack
      align="stretch"
      borderWidth="1px"
      borderColor="gray.600"
      borderRadius="md"
      overflow="hidden"
      gap={0}
    >
      {rows.map((row, index) => (
        <HStack
          key={row.label}
          justify="space-between"
          align="center"
          px="3"
          py="2"
          borderBottomWidth={index < rows.length - 1 ? "1px" : "0"}
          borderBottomColor="gray.600"
          bg="gray.700"
        >
          <Text fontSize="sm" color="gray.300" fontWeight="600">{row.label}</Text>
          <Text fontSize="sm" color="white" fontWeight="700">{row.value}</Text>
        </HStack>
      ))}
    </VStack>
  )
}
